import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ContractDashboard from './ContractsDashboard'; // Ensure the file './ContractDashboard.tsx' exists in the same directory
import ContractList from './ContractsList'; // Ensure the file './ContractList.tsx' exists in the same directory
import ContractForm from './ContractForm';
import AboutSection from '../AboutSection'; // Ensure the file '../AboutSection.tsx' exists in the same directory
import ContractBulkUpload from './ContractBulkUpload';
import SecurityDepositIndex from './security-deposit/SecurityDepositIndex';
import SecurityDepositList from './security-deposit/SecurityDepositList';
import SecurityDepositForm from './security-deposit/SecurityDepositForm';
import ContractDepositList from './ContractDepositList';
import GenericSupportingDocs from '../docsupload/GenericSupportingDocs';
import ContractSupportingDocsWrapper from '../docsupload/ContractSupportingDocsWrapper';

const isAdmin = true; // Replace with real auth logic

// Dynamic wrapper to map route to mode
const ContractFormWrapper: React.FC = () => {
  const location = useLocation();
  const pathname = location.pathname;

  let mode: 'create' | 'edit' | 'view' = 'view';
  if (pathname.endsWith('/create')) mode = 'create';
  else if (pathname.endsWith('/edit')) mode = 'edit';

  console.log('🚀 Contract Form Mode:', mode, 'Path:', pathname);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col w-full p-2">
      <AboutSection title={`Contracts - ${mode}`} iconName="file-text" />
      <ContractForm mode={mode} />
    </div>
  );
};

const ContractsModule: React.FC = () => {
  if (!isAdmin) return <Navigate to="/unauthorized" />;

  return (
    <Routes>
      <Route index element={<ContractDashboard />} />
      <Route path="list" element={<ContractList />} />
      <Route path="contract-deposit" element={<ContractDepositList />} />
      <Route path="contract-deposit/:id" element={<ContractFormWrapper />} />
      <Route path="create" element={<ContractFormWrapper />} />
      <Route path=":id" element={<ContractFormWrapper />} />
      <Route path=":id/edit" element={<ContractFormWrapper />} />
      <Route path="/bulk-upload" element={<ContractBulkUpload />} />
      <Route path=":id/supporting-docs" element={<ContractSupportingDocsWrapper />}/>
      
      <Route path=":contractId/security-deposit" element={<SecurityDepositList/>} />
      <Route path=":contractId/security-deposit/:depositId/edit" element={<SecurityDepositForm />} />
      <Route path=":contractId/security-deposit/:depositId" element={<SecurityDepositForm />} />
      <Route path=":contractId/security-deposit/:depositId/create" element={<SecurityDepositForm />} />


    </Routes>
  );
};

export default ContractsModule;